// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frontend-src-components-anchor-___styles__anchor___wnGCR{transition:all .2s ease-in-out;border-bottom:2px solid transparent;color:#282828;cursor:pointer;font-size:14px;text-decoration:none;font-weight:bold}.frontend-src-components-anchor-___styles__anchor___wnGCR:hover{border-bottom:2px solid #ff6000}.frontend-src-components-anchor-___styles__anchor___wnGCR:active{border:0;color:#ff6000}\n", "",{"version":3,"sources":["webpack://frontend/src/components/anchor/styles.scss"],"names":[],"mappings":"AAAywD,0DAAQ,8BAA8B,CAAC,mCAAmC,CAAC,aAAa,CAAC,cAAc,CAAC,cAAc,CAAC,oBAAoB,CAAC,gBAAgB,CAAC,gEAAc,+BAA+B,CAAC,iEAAe,QAAQ,CAAC,aAAa","sourcesContent":[":export{backgroundOpacity:#081827;black:#282828;boxShadowGrey:rgba(11,9,44,0.2);boxShadowLight:rgba(0,0,0,0.1);boxShadowLighter:rgba(0,0,0,0.05);darkGrey:#adadad;darkerGrey:#656669;error:#fa1931;faintBlue:rgba(28,88,152,0.05);greyOverlay:rgba(0,0,0,0.8);lightGrey:#c6c7c9;lighterGrey:#f3f5fa;lighterOrange:rgba(255,114,0,0.2);lightestGrey:#e9e9e9;mediumGrey:#d4d4d4;opaqueWhite:rgba(255,255,255,0.2);orange1:#ff4000;orange2:#ff6000;orange3:#ff551b;orange3Opacity:rgba(255,85,27,0.2);orange4:#fe7a24;orange5:#ffa21a;orange6:#ff9700;orange7:#ff794c;orange7Opacity:rgba(255,121,76,0.08);orange8:#ff6700;paleBlueBackground:#f8f9fc;paleOrange:rgba(255,87,0,0.2);paleRed:#ffe8ea;paragraphGrey:#757575;peach:#fdc;peachIconBg:#faddcc;success:#59bf28;tealBackground:rgba(26,121,151,0.5);transparent:rgba(0,0,0,0);white:#fff;green1:#219653;blue1:#2f80ed;faintGreyOverlay:rgba(0,0,0,0.5);footerGrey:#f7f7f7}:export{bigButtonHeight:50px;boxShadowBottom:33px;boxShadowRight:13px;buttonWidth:120px;cardHeight:250px;cardWidth:300px;desktop:1024px;desktopMin:1023px;extraLargeFont:80px;heaviest:900;heroPadding:80px;iconPadding:12.5px;inputHeight:38px;inputWidth:100%;inputWidthDesktop:200px;largeFont:60px;largeHeight:350px;largeWidth:400px;marginHorizontal:80px;marginVertical:60px;maxDesktopContainer:1240px;maxGalleryWidth:830px;mediumFont:25px;mediumHeight:300px;mediumLargeFont:40px;mediumSmall:18px;mediumWidth:350px;microFont:6.2px;mobile:480px;paddingHorizontal:40px;paddingVertical:30px;paperBoxShadow:rgba(0,0,0,0.05);paragraphLineHeight:24px;slimButtonHeight:28px;smallFont:16px;smallSpacer:10px;smallestFont:12px;smallestSpacer:5px;spacer:15px;squareButton:50px;squareButtonHeight:50px;standardFont:14px;tablet:768px;tabletMin:767px;tabletNumber:768;widePadding:120px;zIndex1:100;zIndex2:200;zIndex3:300}.anchor{transition:all .2s ease-in-out;border-bottom:2px solid transparent;color:#282828;cursor:pointer;font-size:14px;text-decoration:none;font-weight:bold}.anchor:hover{border-bottom:2px solid #ff6000}.anchor:active{border:0;color:#ff6000}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundOpacity": "#081827",
	"black": "#282828",
	"boxShadowGrey": "rgba(11,9,44,0.2)",
	"boxShadowLight": "rgba(0,0,0,0.1)",
	"boxShadowLighter": "rgba(0,0,0,0.05)",
	"darkGrey": "#adadad",
	"darkerGrey": "#656669",
	"error": "#fa1931",
	"faintBlue": "rgba(28,88,152,0.05)",
	"greyOverlay": "rgba(0,0,0,0.8)",
	"lightGrey": "#c6c7c9",
	"lighterGrey": "#f3f5fa",
	"lighterOrange": "rgba(255,114,0,0.2)",
	"lightestGrey": "#e9e9e9",
	"mediumGrey": "#d4d4d4",
	"opaqueWhite": "rgba(255,255,255,0.2)",
	"orange1": "#ff4000",
	"orange2": "#ff6000",
	"orange3": "#ff551b",
	"orange3Opacity": "rgba(255,85,27,0.2)",
	"orange4": "#fe7a24",
	"orange5": "#ffa21a",
	"orange6": "#ff9700",
	"orange7": "#ff794c",
	"orange7Opacity": "rgba(255,121,76,0.08)",
	"orange8": "#ff6700",
	"paleBlueBackground": "#f8f9fc",
	"paleOrange": "rgba(255,87,0,0.2)",
	"paleRed": "#ffe8ea",
	"paragraphGrey": "#757575",
	"peach": "#fdc",
	"peachIconBg": "#faddcc",
	"success": "#59bf28",
	"tealBackground": "rgba(26,121,151,0.5)",
	"transparent": "rgba(0,0,0,0)",
	"white": "#fff",
	"green1": "#219653",
	"blue1": "#2f80ed",
	"faintGreyOverlay": "rgba(0,0,0,0.5)",
	"footerGrey": "#f7f7f7",
	"bigButtonHeight": "50px",
	"boxShadowBottom": "33px",
	"boxShadowRight": "13px",
	"buttonWidth": "120px",
	"cardHeight": "250px",
	"cardWidth": "300px",
	"desktop": "1024px",
	"desktopMin": "1023px",
	"extraLargeFont": "80px",
	"heaviest": "900",
	"heroPadding": "80px",
	"iconPadding": "12.5px",
	"inputHeight": "38px",
	"inputWidth": "100%",
	"inputWidthDesktop": "200px",
	"largeFont": "60px",
	"largeHeight": "350px",
	"largeWidth": "400px",
	"marginHorizontal": "80px",
	"marginVertical": "60px",
	"maxDesktopContainer": "1240px",
	"maxGalleryWidth": "830px",
	"mediumFont": "25px",
	"mediumHeight": "300px",
	"mediumLargeFont": "40px",
	"mediumSmall": "18px",
	"mediumWidth": "350px",
	"microFont": "6.2px",
	"mobile": "480px",
	"paddingHorizontal": "40px",
	"paddingVertical": "30px",
	"paperBoxShadow": "rgba(0,0,0,0.05)",
	"paragraphLineHeight": "24px",
	"slimButtonHeight": "28px",
	"smallFont": "16px",
	"smallSpacer": "10px",
	"smallestFont": "12px",
	"smallestSpacer": "5px",
	"spacer": "15px",
	"squareButton": "50px",
	"squareButtonHeight": "50px",
	"standardFont": "14px",
	"tablet": "768px",
	"tabletMin": "767px",
	"tabletNumber": "768",
	"widePadding": "120px",
	"zIndex1": "100",
	"zIndex2": "200",
	"zIndex3": "300",
	"anchor": "frontend-src-components-anchor-___styles__anchor___wnGCR"
};
export default ___CSS_LOADER_EXPORT___;
